import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { SharedService } from '../../services/shared.service';
import { ApiService } from '../../services/api.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {
  isLinkSubmitted = false;
  isSubmitted = false;
  isError = '';
  successMsg = '';
  public verifyEmailForm: FormGroup;
  @Input() showModal = false;
  @Output() hideForgotPasswordBox = new EventEmitter<number>();
  constructor(public formBuilder: FormBuilder,
    private _shared: SharedService,
    private router: Router,
    private _api: ApiService) { }

  ngOnInit() {
    this.verifyEmailForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]]
    });
  }

  get formControls() { return this.verifyEmailForm.controls; }

  forgotPassword() {
    this.successMsg = '';
    this.isError = '';
    if (this.verifyEmailForm.invalid) {
      return false;
    }
    this._api.forgotPassword(this.verifyEmailForm.value).subscribe(result => {
      if (result.responseType === 'success') {
        this.isSubmitted = true;
        this.isLinkSubmitted = true;
        // this.successMsg = result.message;
        this.successMsg = 'We have sent a reset password email to ' + this.verifyEmailForm.value.email +
          '. Please click the reset password link to set your new password.';
      } else if (result.responseType === 'error') {
        this.isSubmitted = false;
        this.isLinkSubmitted = false;
        this.successMsg = '';
        this.isError = result.msg;
      }
    }, err => {
      this.isSubmitted = false;
      this.isLinkSubmitted = false;
    });
  }

  back() {
    this.hideForgotPasswordBox.emit(2);
  }
  close() {
    this.router.navigate(['authentication/login']);
    // this.hideForgotPasswordBox.emit(3);
  }
}
